import { matchPath } from "react-router-dom";

// export const isUrlMatch = ({ location }, path) => {
//   if (!location || !path) return false;
//
//   const match = matchPath(
//     {
//       path,
//       end: true // This is equivalent to the old `exact` prop
//     },
//     location.pathname
//   );
//
//   if (!!match) {
//     console.log(`${location.pathname} STRICTLY MATCHES ${path}`);
//   }
//   return !!match;
// };

  export const isUrlMatch = ({ location: { pathname } }, path) =>
    !!matchPath({ path },pathname);
